import React, { forwardRef, FormHTMLAttributes, ReactNode } from 'react';

interface FormProps extends FormHTMLAttributes<HTMLFormElement> {
    children?: ReactNode;
    description: string;
}

const Form = forwardRef<HTMLFormElement, FormProps>((props, ref) => {
    const { children, description, action, method, ...rest } = props;

    return (
        <div className="o-form">
            <form
                ref={ref}
                action={action}
                method={method}
                aria-label={description}
                {...rest}
            >
                {children}
            </form>
        </div>
    );
});

Form.displayName = 'Form';

export { Form, FormProps };
